'use client'
import {providerMap} from '@/auth';
import GoogleLoginButton from '@/components/LoginGoogleButton';
import LinkedInLoginButton from '@/components/LoginLinkedInButton';
import React from 'react';
import {handleLogin} from '@/lib/handle-login-logout';
import config from '@/config'
import SessionState from "@/lib/session-state";

const LoginInWithButton = ({provider}) => {
    switch (provider.name) {
        case 'Google':
            return <GoogleLoginButton provider={provider}></GoogleLoginButton>;
        case 'LinkedIn':
            return <LinkedInLoginButton provider={provider}></LinkedInLoginButton>;
    }
};

export default function ({props}) {


    let interval
    //Hack Alert. Auth JS does not redirect fully after credentials login.
    //"handleLogin" will add ?logged-in=true to the url, we'll watch for that change here,
    //then refresh the window so the SessionProvider picks up the change.
    const onLoginWithEmail = () => {
        clearInterval(interval)
        interval = setInterval(() => {
            console.log("checking for redirect", window.location.search)
            if (window.location.search === '?logged-in=true') {
                clearInterval(interval)
                setTimeout(() => {
                    SessionState.checkIsLoggedIn().then();
                }, 500)
                //window.location.search = ''
                // @ts-ignore
                // window.location = "/"
            }
        }, 500)

    }

    // @ts-ignore
    return (
        <div className="flex flex-column grow items-center w-full justify-center ">
            <div className="w-full mx-2 md:mx-0">
                <div className="flex flex-col gap-2 ">
                    {Object.values(providerMap).map((provider, index) => (
                        <form action={handleLogin} key={'provider-' + index} data-provider={provider.id}>
                            <input type="hidden" name="provider" value={provider.id}/>
                            <LoginInWithButton
                                provider={provider}
                                key={'provider-' + index}
                            />
                        </form>
                    ))}
                    <hr/>
                    {config.AUTH_CREDENTIALS === "true" && (
                        <form
                            className="relative justify-start items-center flex flex-col w-full"
                            action={handleLogin}
                            data-provider="credentials"
                        >
                            <fieldset className="border p-4 w-full">
                                <legend>Sign In With EIDR Credentials</legend>

                                <><input type="hidden" name="provider" value="credentials"/><span>
                                  <label htmlFor="email" className="w-full">
                                      Username
                                      <input
                                          name="username"
                                          id="username"
                                          required={true}
                                          className="border rounded w-full mb-3 h-10 px-2"/>
                                  </label>
                                  <label htmlFor="password" className="w-full">
                                      Password
                                      <input
                                          name="password"
                                          id="password"
                                          type="password"
                                          required={true}
                                          className="border rounded w-full mb-3 h-10 px-2"/>
                                  </label>
                                  <input
                                      type="submit"
                                      className="bg-theme-blue p-2 w-full text-white mb-2  cursor-pointer"
                                      value="Sign In"
                                      onClick={onLoginWithEmail}/>
                              </span></>


                            </fieldset>
                        </form>
                    )
                    }
                </div>
            </div>
        </div>
    );
}
